import { all, call, takeEvery, fork, take } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newRequestFunction from "../Utils/newSGF";

import {
  ADD_SKILL_SET,
  FETCH_ALL_SKILL_SET,
  ACTIVATE_SKILL_SET,
  DEACTIVATE_SKILL_SET,
  FETCH_SKILL_SET_BY_ID,
  CREATE_SUBSKILL,
  FETCH_SUBSKILL_BY_SKILL_ID,
  FETCH_ALL_TOTAL_SKILLS_DATA,
  UPDATE_SKILL_SET,
  UPDATE_SUB_SKILL,
  FETCH_SKILLCENTRES_BY_STATE,
  EXPORT_SKILLS,
  PRINT_SKILLS,
  UPDATE_MULTIPLE_SUB_SKILLS,
  IMPORT_SKILL_SET,
  IMPORT_SUB_SKILL
} from "../ActionTypes";

import {
  addSkillSetSuccess,
  fetchSkillSetSuccess,
  activateSkillSetSuccess,
  deactivateSkillSetSuccess,
  fetchSkillSetByIdSuccess,
  addSubSkillsSuccess,
  fetchSubSkillBySkillIdSuccess,
  fetchAllTotalSkillsDataSuccess,
  updateSkillSetSuccess,

  updateSubSkillSuccess,
  updateSubSkillFailure,
  
  fetchSkillCentreByStateIdSuccess,
  exportSkillFileSuccess,
  printSkillsPdfSuccess,
  updateMultipleSubSkillSuccess,
  importSkillSetSuccess,
  importSubSkillSuccess
} from "../Actions";

import {
  createSkills, 
  getAllSkills, 
  activateSkills,
  deactivateSkills, 
  getSkillsById, 
  createSubSkill, 
  getSubSkillBySkillId, 
  getAllTotalSkillsData, 
  updateSkillSet, 
  updateSubSkill, 
  getSkillCentresByStateId, 
  exportSkills, 
  printSkills, 
  updateMultipleSubSkillApi, 
  importSkillSetApi, 
  importSubSkillApi, /* getSkillCentresById */
} from "../Api";

// =================Create New Skills sagas================

const createSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, addSkillSetSuccess, createSkills, payload);
};

export const createSkillSet = function* () {
  yield takeEvery(ADD_SKILL_SET, createSkillSetRequest);
};

// =================FETCH ALL Skills sagas================
const fetchSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSkillSetSuccess, getAllSkills, payload);
};

export const fetchSkillSet = function* () {
  yield takeEvery(FETCH_ALL_SKILL_SET, fetchSkillSetRequest);
};


// =================Activate Skills sagas================

const activateSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, activateSkillSetSuccess, activateSkills, payload);
};

export const activateSkillSet = function* () {
  yield takeEvery(ACTIVATE_SKILL_SET, activateSkillSetRequest);
};


// =================Dectivate Skills sagas================

const deactivateSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, deactivateSkillSetSuccess, deactivateSkills, payload);
};

export const deactivateSkillSet = function* () {
  yield takeEvery(DEACTIVATE_SKILL_SET, deactivateSkillSetRequest);
};


// =================Fetch Skill by Id  sagas================

const fetchSkillSetByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSkillSetByIdSuccess, getSkillsById, payload);
};

export const fetchSkillSetById = function* () {
  yield takeEvery(FETCH_SKILL_SET_BY_ID, fetchSkillSetByIdRequest);
};


// =================Create Sub Skill sagas================

const createSubSkillRequest = function* ({ payload }) {
  yield call(requestFunction, addSubSkillsSuccess, createSubSkill, payload);
};

export const createSubSkills = function* () {
  yield takeEvery(CREATE_SUBSKILL, createSubSkillRequest);
};


// =================FETCH Sub Skill by Skill Id sagas================

const fetchSubSkillBySkillIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSubSkillBySkillIdSuccess, getSubSkillBySkillId, payload);
};

export const fetchSubSkillBySkillId = function* () {
  yield takeEvery(FETCH_SUBSKILL_BY_SKILL_ID, fetchSubSkillBySkillIdRequest);
};

// =================Update Skill set sagas================
const updateSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, updateSkillSetSuccess, updateSkillSet, payload);
};

export const updateTheSkillSet = function* () {
  yield takeEvery(UPDATE_SKILL_SET, updateSkillSetRequest);
};

// =================Update Skill set sagas================
const updateSubSkillRequest = function* ({ payload }) {
  yield call(newRequestFunction, updateSubSkillSuccess, updateSubSkillFailure, updateSubSkill, payload);
};

export const updateSubSkills = function* () {
  yield takeEvery(UPDATE_SUB_SKILL, updateSubSkillRequest);
};


// =================FETCH ALL Skills Total sagas================
const fetchAllSkillsTotalDataRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllTotalSkillsDataSuccess, getAllTotalSkillsData, payload);
};

export const fetchTotalSkillsData = function* () {
  yield takeEvery(FETCH_ALL_TOTAL_SKILLS_DATA, fetchAllSkillsTotalDataRequest);
};

// =================Fetch SkillCentre by State Id  sagas================

const fetchSkillCentreByStateIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSkillCentreByStateIdSuccess, getSkillCentresByStateId, payload);
};

export const fetchSkillCentreByState = function* () {
  yield takeEvery(FETCH_SKILLCENTRES_BY_STATE, fetchSkillCentreByStateIdRequest);
};

// =================EXPORT Skills sagas================
const exportSkillFileRequest = function* ({ payload }) {
  yield call(requestFunction, exportSkillFileSuccess, exportSkills, payload);
};

export const exportSkillFile = function* () {
  yield takeEvery(EXPORT_SKILLS, exportSkillFileRequest);
};

export const PrintSkillFileRequest = function* ({ payload }) {
  yield call(requestFunction, printSkillsPdfSuccess, printSkills, payload)
};

export const PrintSkillFile = function* () {
  yield takeEvery(PRINT_SKILLS, PrintSkillFileRequest);
}


// =================Update Multiple Sub Skill  set sagas================
const updateMultipleSubSkillRequest = function* ({ payload }) {
  yield call(requestFunction, updateMultipleSubSkillSuccess, updateMultipleSubSkillApi, payload);
};

export const updateMultipleSubSkills = function* () {
  yield takeEvery(UPDATE_MULTIPLE_SUB_SKILLS, updateMultipleSubSkillRequest);
};


// =================Import Skill Set sagas================

const importSkillSetRequest = function* ({ payload }) {
  yield call(requestFunction, importSkillSetSuccess, importSkillSetApi, payload);
};

export const importSkillSetBulkUpload = function* () {
  yield takeEvery(IMPORT_SKILL_SET, importSkillSetRequest);
};


// =================Import Sub Skill sagas================

const importSubSkillRequest = function* ({ payload }) {
  yield call(requestFunction, importSubSkillSuccess, importSubSkillApi, payload);
};

export const importSubSkillBulkUpload = function* () {
  yield takeEvery(IMPORT_SUB_SKILL, importSubSkillRequest);
};







export default function* rootSaga() {
  yield all([fork(createSkillSet), fork(fetchSkillSet), fork(activateSkillSet), fork(deactivateSkillSet), fork(fetchSkillSetById), fork(createSubSkills), fork(fetchSubSkillBySkillId), fork(fetchTotalSkillsData), fork(updateTheSkillSet), fork(updateSubSkills), fork(fetchSkillCentreByState), fork(exportSkillFile), fork(PrintSkillFile), fork(updateMultipleSubSkills), fork(importSkillSetBulkUpload), fork(importSubSkillBulkUpload)]);
}
